<template>
  <div>
    <div v-if="loading">
      <div class="text-center">
        <b-spinner
          small
          variant="primary"
          type="grow"
          label="Spinning"/>
        <b-spinner
          small
          variant="primary"
          type="grow"
          label="Spinning"/>
        <b-spinner
          small
          variant="primary"
          type="grow"
          label="Spinning"/>
      </div>
    </div>
    <div v-else>
      <div v-if="services != null && services.length === 0">
        <b-row class="align-center">
          <b-col><i>Aucun service</i></b-col>
        </b-row>
      </div>
      <div v-else>
        <b-button
          v-b-toggle="'list-invisible-services'"
          class="m-1"
          variant="info">
            <span class="when-open"><font-awesome-icon :icon="['fas', 'chevron-up']" />&nbsp;</span>
            <span class="when-closed"><font-awesome-icon :icon="['fas', 'chevron-down']" />&nbsp;</span>
            {{$t('label.list_services')}}
          
          </b-button>
        <b-collapse id="list-invisible-services">
          <b-table
            :fields="fields"
            :items="services"
            small
            responsive="sm">
            <template #cell(serv_data)="row">
              <div
                :style="{background: getColorFromData(row.item.serv_data)}"
                class="square"/>
            </template>
            <template #cell(serv_is_enable)="row">
              <b-badge :variant="row.item.serv_is_enable ? 'success' : 'danger'" >
                {{ row.item.serv_is_enable ? $t('label.active') : $t('label.inactive') }}
              </b-badge>
            </template>
            <template #cell(serv_is_default)="row">
              <b-badge :variant="row.item.serv_is_default ? 'success' : 'danger'" >
                {{ row.item.serv_is_default ? $t('label.yes') : $t('label.no') }}
              </b-badge>
            </template>
            <template #cell(update)="row">
              <b-col><b-button
                v-b-modal="'modal-update-service-'+ row.item.serv_id"
                size="sm"
                variant="primary">{{ $t("btn.update") }}</b-button></b-col>
              <b-modal
                :id="'modal-update-service-'+ row.item.serv_id"
                title="Modifier un service"
                scrollable
                hide-footer>
                <form-service
                  :service="row.item"
                  :id="id"
                  :allow-default="allowNewDefault"
                  @sendForm="receiveUpdate"/>
              </b-modal>
            </template>
          </b-table>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>

import FormImportList from '../forms/FormImportList.vue';
import FormService from '../forms/FormService.vue';

export default {
  name: 'ListService',
  components: {
    FormImportList,
    FormService,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      title: 'List Service',
      fields: [
        {
          serv_data: {
            label: this.$t("label.color"),
            tdClass: 'align-middle',
          },
        },
        {
          serv_name: {
            label: this.$t("label.name"),
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          serv_type: {
            label: this.$t("label.type"),
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          serv_is_enable: {
            label: this.$t("label.active"),
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          serv_is_default: {
            label: this.$t("label.default"),
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          update: {
            label: this.$t("btn.update"),
            sortable: false,
            tdClass: 'align-middle',
          },
        },
      ],
      loading: true,
    };
  },
  computed: {
    services() {
      return this.$store.getters['establishments/servicesByEstaId'](this.id);
    },
    allowNewDefault() {
      return !this.services.some(service => service.serv_is_default);
    },
  },
  async mounted() {
    await this.$store.dispatch('establishments/getServices', this.id);
    this.loading = false; 
  },
  methods: {
    receiveForm(formList) {
      this.$root.$emit('bv::hide::modal', 'modal-import-staff-list');
      this.$store.dispatch('establishments/importStaffsList', [this.id, formList]);
    },
    async receiveUpdate(formService) {
      const servId = JSON.parse(formService).serv_id;
      this.$root.$emit('bv::hide::modal', `modal-update-service-${servId}`);
      const value = await this.$store.dispatch('establishments/setService', formService);
      if (value && value.data) await this.$store.dispatch('establishments/getServices', this.id);
      this.loading = false;
    },
    getColorFromData(data) {
      return data && data.display && data.display.color ? data.display.color : '#CACACA';
    },
  },
};
</script>
<style>
.square {
  width: 20px;
  height: 20px;
  border-radius: 5px;
  margin: auto;
}
</style>
